import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import PersonGroup from "../../../types/PersonGroup"

export interface componentProps {
    item: PersonGroup
}

const ItemDataSource: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.data_source')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel position="fixed">{t('common.source_name')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.dataSource?.name || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel position="fixed">{t('common.source_item_id')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.sourceItemId || '-'}</IonNote>
            </IonItem>
        </IonItemGroup>
    )
}

export default ItemDataSource